import React, { Component } from "react";
import { Icon, message, Tooltip, Modal } from 'antd';
import LangContext from "../contextProvider/LangContext";
import { Job, OutputType, ProcessType, User } from "../JmReact.js";

class SMSBalance extends Component<Props, State> {

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    render() {
        return (<span>
            <Tooltip title={this.getText(20857)}>
                <Icon
                    type={'wechat'}
                    style={{ marginLeft: '40px', color: '#fff' }}
                    onClick={() => {
                        this.sendAPI("get_message_summeraized", "", ob => {
                            let data = ob.data ? ob.data.split("\r") : []
                            let _balance = data[1] ? data[1].split("\f")[3] : null
                            Modal.confirm({
                                content: (<h2 dir="rtl">{this.getText(20858)}: {_balance}</h2>),
                                iconType: 'exclamation-circle',
                                okButtonProps: { style: { display: 'none' } },
                                cancelText: this.getText(20859),
                                onOk() { },
                                onCancel() { },
                            })
                        })
                    }}
                />
            </Tooltip>
        </span>)
    }

}

export default SMSBalance;